import Desktop from 'components/Header/desktop';
import Mobile from 'components/Header/mobile';
import Tablet from 'components/Header/tablet';
import { useAuth } from 'contexts/auth';
import { useViewport } from 'contexts/viewport';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const getNavOptions = (path, role, t) => {
    if (!role) {
        return [
            {
                key: 'lobby',
                text: t('nav.lobby', 'Lobby'),
                link: '/',
                icon: 'home',
            },
            {
                key: 'rubrics',
                text: t('nav.rubrics', 'Rubrics'),
                link: '/rubrics',
                icon: 'dashboard',
            },
        ];
    }

    return path === '/'
        ? [
              {
                  key: 'lobby',
                  text: t('nav.lobby', 'Lobby'),
                  link: '/',
                  icon: 'home',
              },
              {
                  key: 'rubrics',
                  text: t('nav.rubrics', 'Rubrics'),
                  link: '/rubrics',
                  icon: 'dashboard',
              },
          ]
        : {
              student: [
                  {
                      key: 'lobby',
                      text: t('nav.lobby', 'Lobby'),
                      link: '/',
                      icon: 'home',
                  },
                  {
                      key: 'assignments',
                      text: t('nav.assignments', 'Assignments'),
                      link: '/assignments',
                      icon: 'task',
                  },
              ],
              instructor: [
                  {
                      key: 'lobby',
                      text: t('nav.lobby', 'Lobby'),
                      link: '/',
                      icon: 'home',
                  },
                  {
                      key: 'assignments',
                      text: t('nav.assignments', 'Assignments'),
                      link: '/assignments',
                      icon: 'task',
                  },
                  {
                      key: 'rubrics',
                      text: t('nav.rubrics', 'Rubrics'),
                      link: '/rubrics',
                      icon: 'dashboard',
                  },
                  {
                      key: 'people',
                      text: t('nav.people', 'People'),
                      link: '/people',
                      icon: 'teams',
                  },
              ],
              ta: [
                  {
                      key: 'assignments',
                      text: t('nav.assignments', 'Assignments'),
                      link: '/assignments',
                      icon: 'task',
                  },
                  {
                      key: 'rubrics',
                      text: t('nav.rubrics', 'Rubrics'),
                      link: '/rubrics',
                      icon: 'dashboard',
                  },
                  {
                      key: 'people',
                      text: t('nav.people', 'People'),
                      link: '/people',
                      icon: 'teams',
                  },
              ],
          }[role];
};

const getDropdownOptions = (hasCourseSelected, role, t) => {
    const universalDropdownOptions = [
        { key: 'user' },
        { key: 'divider' },
        { key: 'profile', value: t('header.account-settings', 'Account Settings') },
    ];

    return [
        ...universalDropdownOptions,
        ...(hasCourseSelected
            ? [
                  ...(role === 'instructor'
                      ? [{ key: 'course-settings', value: t('header.course-settings', 'Course Settings') }]
                      : []),
                  { key: 'switch-course', value: t('header.switch-course', 'Switch Course') },
              ]
            : []),
    ];
};

const Header = () => {
    const { auth } = useAuth();
    const location = useLocation();
    const { device } = useViewport();
    const { t } = useTranslation();

    const navOptions = getNavOptions(location.pathname, auth.role, t);
    const dropdownOptions = getDropdownOptions(auth.owner_account_id, auth.role, t);

    const props = {
        navOptions,
        dropdownOptions,
    };

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    return isEmpty(auth) ? null : renderResponsiveLayout(device);
};

export default Header;
